import subdivisionsJson from './subdivisions.json';

export const SUBDIVISION_COUNTRY_CODES = ['US', 'CA'] as const;

export type SubdivisionCountryCode = (typeof SUBDIVISION_COUNTRY_CODES)[number];

export const isSubdivisionCountryCode = (
  country: string | undefined
): country is SubdivisionCountryCode =>
  country !== undefined &&
  (SUBDIVISION_COUNTRY_CODES as readonly string[]).includes(country);

export interface SubdivisionRecord {
  code: string;
  name: string;
}

export type SubdivisionsData = Record<
  SubdivisionCountryCode,
  SubdivisionRecord[]
>;

export const SUBDIVISIONS = subdivisionsJson;

export const getSubdivisionCodesForCountry = (
  country: SubdivisionCountryCode
): string[] => SUBDIVISIONS[country].map((row) => row.code);

export const getSubdivisionLabelForCode = (code: string): string => {
  for (const country of SUBDIVISION_COUNTRY_CODES) {
    const row = SUBDIVISIONS[country].find((r) => r.code === code);
    if (row) {
      return row.name;
    }
  }
  return code;
};
